import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProcessToken = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Extract the token from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      // Store the token in localStorage
      localStorage.setItem('authToken', token);

      // Optionally: Clear the token from the URL (replace state to remove query params)
      window.history.replaceState({}, document.title, window.location.pathname);

      // Redirect to the home page
      navigate('/home');
    } else {
      // If no token, redirect to login (or handle appropriately)
      navigate('/');
    }
  }, [navigate]);

  // Optionally display a loading spinner while processing the token
  return <div>Processing token...</div>;
};

export default ProcessToken;
